import { styled } from '@mui/material/styles';

export const ContentStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    maxWidth: '380px',
    padding: '48px 22px',
    margin: 'auto',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.default,
    border: '1px solid',
    borderColor: theme.palette.secondary.main,
    borderRadius: '10px',
  },
  maxWidth: '500px',
  padding: 25,
  margin: 'auto',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  background: theme.palette.background.default,
  border: '1px solid',
  borderColor: theme.palette.secondary.main,
  borderRadius: '10px',
}));
